<pagination-template
    [id]="id"
    #p="paginationApi"
    (pageChange)="pageChange.emit($event)">

    <p class="float-left pagination-meta">
        <span *ngIf="total">
            {{ 'shared.pagination.meta' | translate : { from: from, to: to , total: total } }}
        </span>
        <!-- <span *ngIf="!total">
            {{ 'shared.pagination.empty' | translate }}
        </span> -->
    </p>

    <ul class="float-right pagination" *ngIf="!(autoHide && p.pages.length <= 1)">
        <li [class.disabled]="p.isFirstPage()">
            <a (click)="p.previous()">
                <i class="i i-arrow-left"></i>
            </a>
        </li>
        <li *ngFor="let page of p.pages" [class.active]="p.getCurrent() === page.value">
            <a (click)="p.setCurrent(page.value)">
                {{ page.label }}
            </a>
        </li>
        <li [class.disabled]="p.isLastPage()">
            <a (click)="p.next()">
                <i class="i i-arrow-right"></i>
            </a>
        </li>
    </ul>
</pagination-template>
